module.exports = __webpack_public_path__ + "images/kaitori_bonus_cp_lp/step-3-buyback_7b8036f1a281992961bfb432e568b341.png";